export const PortalBooleanFlagKeys = {
  portalHomePoc: 'portal-home-poc',
} as const;

export type PortalBooleanFlagKey =
  (typeof PortalBooleanFlagKeys)[keyof typeof PortalBooleanFlagKeys];
